import {
    getLogLoading,
    getLogReject,
    getLogRequest,
    getLogSuccess
} from "../../actions/log/getAll";

export const getLog = (formData) => async (dispatch, getState) => {
    dispatch(getLogLoading());
    try {
        const { data } = await getLogRequest(formData, getState);
        dispatch(getLogSuccess(data))
    } catch (error) {
        dispatch(getLogReject(error))
    }
    return Promise.resolve();
};